<template>
  <div class="offer-card">
    <div v-bind:id="slug" class="offer-card__front">
      <img loading="lazy" v-if="image" v-bind:src="imageSrc" alt="" class="offer-card__image" />
      <div class="offer-card__content">
        <div class="offer-card__header">
          <div>
            <div class="offer-card__meta" v-if="meta">{{meta}}</div>
            <h3 class="offer-card__title">{{name}}</h3>
          </div>
          <span class="offer-card__price" v-if="price">{{price}}€</span>
        </div>
        <div class="offer-card__description" v-html="description"></div>
        
        <address v-if="address">
          <b-icon-geo-alt></b-icon-geo-alt>{{address}}
        </address>
        <a v-if="contact" v-bind:href="`tel:${contact}`" class="phone">{{contact}}</a>
        
        <a v-if="companies" v-on:click="showCompanies" v-bind:href="`#${slug}-details`" class="offer-card__link">Ver Empresas</a>
        <router-link class="offer-card__link" v-if="routing" v-bind:to="routing">Ver Mais</router-link>

        <div class="mt-4" v-if="blocks">
          <div class="mb-4" v-for="block in blocks" v-bind:key="block.id">
            <h4 class="offer-card__title">{{block.name}}</h4>
            <div class="offer-card__description" v-html="block.description"></div>
            <address v-if="block.address">
              <b-icon-geo-alt></b-icon-geo-alt>{{block.address}}
            </address>
            <a v-if="block.contact" v-bind:href="`tel:${block.contact}`" class="phone">{{block.contact}}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="companies" v-bind:id="`${slug}-details`" class="offer-card__back">
      <div class="offer-card__content">
        <a v-bind:href="`#${slug}`" v-on:click="hideCompanies" class="offer-card__close"><span class="sr-only">fechar</span>⨉</a>
        <h3 class="offer-card__title">Empresas</h3>
        <ul class="offer-card__list">
          <li v-for="company in companies" v-bind:key="company">{{company}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconGeoAlt } from 'bootstrap-vue'

export default {
  name: 'Experience',
  props: {
    image: String,
    name: String,
    description: String,
    address: String,
    contact: String,
    price: Number,
    meta: String,
    blocks: Array,
    companies: Array,
    routing: String
  },
  computed: {
    imageSrc: function() {
      return require('./../assets/images/' + this.image)
    },
    slug: function() {
      let candidate = this.name
      candidate = candidate.replace(/^\s+|\s+$/g, '')
      candidate = candidate.toLowerCase()

      const from = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const to = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      for (let i = 0, l = from.length ; i < l ; i++) {
        candidate = candidate.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      candidate = candidate.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                           .replace(/\s+/g, '-') // collapse whitespace and replace by -
                           .replace(/-+/g, '-')

      return candidate
    }
  },
  components: {
    BIconGeoAlt
  },
  methods: {
    showCompanies: function(event) {
      event.preventDefault()
      const target = event.currentTarget.closest('.offer-card')
      target.classList.add('offer-card--expanded')
    },
    hideCompanies: function(event) {
      event.preventDefault()
      const target = event.currentTarget.closest('.offer-card')
      target.classList.remove('offer-card--expanded')
    }
  }
}
</script>